(function () {
  function init(sectionEl) {
    var tabs = Array.from(sectionEl.querySelectorAll('.mission-tabs__tab'));
    var contents = Array.from(sectionEl.querySelectorAll('.mission-tabs__content'));
    var images = Array.from(sectionEl.querySelectorAll('.mission-tabs__image'));

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        contents.forEach(function (c) { c.classList.remove('is-active'); });
        images.forEach(function (img) { img.classList.remove('is-active'); });
        tab.classList.add('is-active');
        if (contents[i]) contents[i].classList.add('is-active');
        if (images[i]) images[i].classList.add('is-active');
      });
    });
  }

  document.querySelectorAll('.mission-tabs').forEach(init);
})();
